export default "__VITE_ASSET__CY5XhGId__"